export default function mixin(behavior) {
    const instanceKeys = [];

    Object.keys(behavior).forEach(key => instanceKeys.push(key));

    return function _mixin(clazz) {
        instanceKeys.forEach(property => {
            clazz.prototype[property] = behavior[property];
        });

        return clazz;
    };
}
